import React, { Component } from 'react';
import _ from 'lodash';
import moment from 'moment';

import TrafficSignsStatesTable from '../components/TrafficSignsStatesTable';
import TrafficSignsSelect from '../components/TrafficSignsSelect';

import TrafficSignsStatesModel from '../components/TrafficSignsStatesModel';
import UserModel from '../components/UserModel';

import { Layout, Button, Row, Col, Input, Icon, DatePicker, message } from 'antd';

class TrafficSignsStatesScreen extends Component {

  state = {
    dataLoading: true,
    dataAll: [],
    data: [],
    dateFrom: moment().subtract(30, 'minutes'),
    dateTo: moment().endOf('day'),
    trafficSignSerialNumber: null
  }

  componentWillMount() {
    this.loadData(this.state.dateFrom, this.state.dateTo, this.state.trafficSignSerialNumber);
  }

  loadData(dateFrom = null, dateTo = null, trafficSignSerialNumber = null) {
    dateFrom = dateFrom ? dateFrom.format() : null;
    dateTo = dateTo ? dateTo.format() : null;
    this.setState({
      dataLoading: true
    });
    TrafficSignsStatesModel.getAll(dateFrom, dateTo, trafficSignSerialNumber)
      .then(data => {
        this.setState({
          dataLoading: false,
          dataAll: data,
          data: data
        });
      })
      .catch(() => {
        message.warning('Data se nepodařilo načíst. Zkontrolujte spravnou funkčnost služby.')
        this.setState({
          dataLoading: false,
        });
      });
  }

  onSearchDescription(searchText) {
    const dataAll = this.state.dataAll;
    this.setState({
      data: _.filter(dataAll, (d) => {
        return d['description'].toLowerCase().includes(searchText.toLowerCase());
      })
    });
  }

  onDateRangeChanged(dates, dateStrings) {
    this.setState({
      dateFrom: dates[0],
      dateTo: dates[1]
    });
    this.loadData(dates[0], dates[1], this.state.trafficSignSerialNumber);
  }

  render() {
    return (
      <Layout.Content style={{ margin: '24px 16px 0', minHeight: 'auto' }}>
        <div style={{ padding: 24, background: '#fff' }}>
          <h2>Informační tabule - Stavy</h2>
          <div style={{ marginBottom: '20px' }}>
            <Row>
              <Col span={16}>
                <TrafficSignsSelect
                  allowClear={true}
                  onChange={(value) => {
                    this.loadData(this.state.dateFrom, this.state.dateTo, value);
                    this.setState({ trafficSignSerialNumber: value });
                  }}
                  style={{ width: 200 }} />
                {' '}
                <Input.Search
                  placeholder="Najít popis"
                  onSearch={this.onSearchDescription.bind(this)}
                  style={{ width: 200 }} />
                <DatePicker.RangePicker
                  defaultValue={[
                    this.state.dateFrom,
                    this.state.dateTo
                  ]}
                  ranges={{
                    "Dnes": [moment().startOf('day'), moment().endOf('day')],
                    "Včera": [moment().add(-1, 'days').startOf('day'), moment().add(-1, 'days').endOf('day')],
                    "Poslední týden": [moment().add(-7, 'days').startOf('day'), moment().endOf('day')],
                  }}
                  allowClear={false}
                  placeholder={['Od', 'Do']}
                  format="DD.MM.YYYY HH:mm"
                  showTime={{ format: 'HH:mm' }}
                  onOk={this.onDateRangeChanged.bind(this)}
                  style={{ width: 300 }} />
              </Col>
              <Col span={8} style={{ textAlign: 'right' }}>
                <Button type="default"
                  onClick={() => {
                    this.loadData(this.state.dateFrom, this.state.dateTo, this.state.trafficSignSerialNumber);
                  }}
                  style={{ marginRight: 10 }}>
                  <Icon type="sync" />
                </Button>
              </Col>
            </Row>
          </div>
          <TrafficSignsStatesTable
            data={this.state.data}
            loading={this.state.dataLoading} />
        </div>
      </Layout.Content>
    );
  }
}

export default TrafficSignsStatesScreen;



// WEBPACK FOOTER //
// ./src/screens/TrafficSignsStatesScreen.js